const State = {
  customers: [],
  customerIdNameList: []
}

export default State
